import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    cookie: true,
    tutorial: true,
    shared: 0,
    isFacebook: false,
    markers: {
      crown: false,
      singer: false,
      singerb: false,
      card: false,
      mrfleur: false,
      trone: false,
    },
    email: null,
  },
  mutations: {
    'SET_FACEBOOK' (state, key) {
      state.isFacebook = true
    },
    'SET_TUTORIAL' (state, key) {
      state.tutorial = key
    },
    'SET_COOKIE' (state) {
      state.cookie = false
    },
    'ADD_SHARE' (state) {
      state.shared = state.shared + 1
    },
    'SET_SHARE' (state, nb) {
      state.shared = nb
    },
    'SET_SUCCESS' (state) {
      state.success = false
    },
    'SET_MARKER' (state, key) {
      state.markers[key] = true
    },
    'SET_EMAIL' (state, data) {
      state.email = data.email

      if(data.checkbox) {
        const axios = Axios.create()

        axios.post('/wp-json/origin/v1/salesforce', { email: data.email, lang: data.lang }).then(res => {
          console.log(res)
        })
      }
    },
  },
  getters: {
    email: state => state.email,
    markers: state => state.markers,
    cookie: state => state.cookie,
    tutorial: state => state.tutorial,
    success: state => state.success,
    shared: state => state.shared,
    isFacebook: state => state.isFacebook,
  }
}
